import { Avatar, Box, Card, Divider, Typography, useTheme } from '@mui/material';
import { type FC, useState } from 'react';
import type { AmsPartUsedType } from '../../models';
import { LightboxGallery } from '../Dialogs';

interface IProps {
  amsPartsUsed: AmsPartUsedType;
}

export const VisitAmsPart: FC<IProps> = ({ amsPartsUsed: { amsPartType, quantity, amsPartBrewerName, medias } }) => {
  const theme = useTheme();
  const [toggle, setToggle] = useState(false);

  const isLightTheme = (localStorage.getItem('appTheme') || 'AvaniLightTheme') === 'AvaniLightTheme';
  const bgColorPrimary = isLightTheme ? theme.colors.avani.turc : theme.colors.avani.teal;
  const bgColorSecondary = isLightTheme ? theme.colors.avani.teal : theme.colors.avani.turc;

  return (
    <Card
      sx={{
        m: '0 auto',
        borderRadius: 1,
        p: '2px 4px',
        border: `2px solid ${medias?.length ? theme.colors.avani.magenta : bgColorPrimary}`,
        backgroundColor: bgColorPrimary,
        width: 'fit-content',
        cursor: medias?.length ? 'pointer' : '',
        boxShadow: 'none'
      }}
      onClick={() => (medias?.length ? setToggle(true) : void 0)}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '60px auto',
          columnGap: 0.5,
          width: 'fit-content'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.colors.avani.aGrey,
            textAlign: 'end',
            pr: '5px',
            borderRight: `1px dashed ${theme.colors.avani.aGrey}`
          }}
        >
          Part
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              color: bgColorSecondary,
              alignSelf: 'baseline'
            }}
          >
            {amsPartType}
          </Typography>
          <Avatar
            variant="rounded"
            sx={{ height: 14, width: 25, fontSize: 12, background: theme.colors.avani.magenta }}
          >
            x{quantity}
          </Avatar>
        </Box>
      </Box>

      <Box width="100%">
        <Divider
          sx={{
            borderBottom: `1px dashed ${theme.colors.avani.aGrey}`,
            backgroundColor: 'transparent'
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '60px auto',
          columnGap: 0.5,
          width: 'fit-content'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.colors.avani.aGrey,
            textAlign: 'end',
            pr: '5px',
            borderRight: `1px dashed ${theme.colors.avani.aGrey}`
          }}
        >
          Brewer
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: bgColorSecondary,
            alignSelf: 'baseline'
          }}
        >
          {amsPartBrewerName}
        </Typography>
      </Box>
      {!!medias?.length && (
        <LightboxGallery
          open={toggle}
          index={0}
          handleClose={() => {
            setToggle(false);
          }}
          imageSrc={medias}
          theme={theme}
        />
      )}
    </Card>
  );
};
